export const GET_LAUNCHPADUSERS_REQUEST = 'GET_LAUNCHPADUSERS_REQUEST';
export const GET_LAUNCHPADUSERS_DATA = 'GET_LAUNCHPADUSERS_DATA';
export const GET_LAUNCHPADUSERS_ERROR = 'GET_LAUNCHPADUSERS_ERROR';

export const UPDATE_QUICK_FILTER = 'UPDATE_QUICK_FILTER';
export const FILTER_LAUNCHPADUSERS = 'FILTER_LAUNCHPADUSERS';
export const SET_LAUNCHPADUSERS_SORT_DATA = 'SET_LAUNCHPADUSERS_SORT_DATA';
export const SORT_LAUNCHPADUSERS = 'SORT_LAUNCHPADUSERS';

export const UPDATE_LAUNCHPADUSER_REQUEST = 'UPDATE_LAUNCHPADUSER_REQUEST';
export const UPDATE_LAUNCHPADUSER_DATA = 'UPDATE_LAUNCHPADUSER_DATA';
export const UPDATE_LAUNCHPADUSER_ERROR = 'UPDATE_LAUNCHPADUSER_ERROR';

export const RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_REQUEST =
  'RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_REQUEST';
export const RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_DATA =
  'RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_DATA';
export const RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_ERROR =
  'RESEND_LAUNCHPADUSER_ACTIVATION_EMAIL_ERROR';
